'use client'

import { type Route } from 'next'
// eslint-disable-next-line no-restricted-imports
import { usePathname } from 'next/navigation'
// eslint-disable-next-line no-restricted-imports
import { useRouter as nextProgressBarUseRouter } from '@bprogress/next/app'
import { BProgressOptions } from '@bprogress/next'
import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const useTypedPathname = usePathname as () => Route<string>

export const useRouter = nextProgressBarUseRouter as () => Omit<
  ReturnType<typeof nextProgressBarUseRouter>,
  'push' | 'replace'
> & {
  push: <T extends string>(href: Route<T>, options?: NavigateOptions, BProgressOptions?: BProgressOptions) => void
  replace: <T extends string>(href: Route<T>, options?: NavigateOptions, BProgressOptions?: BProgressOptions) => void
}
